import React, {Component} from 'react';
import '../../Home.css';

let _this;

class HeaderNavCompact extends Component {

    constructor(props, context) {
        super(props);
        _this = this;
    }

    render() {
        return <div className="card" id="shellPrimaryNoPadding">
            <div className="fast_nav container">
                <ul>
                    <li className="first">
                        <a href="https://timeslots.pro">TimeSlots Pro</a>
                    </li>
                    <li>
                        <a href="https://upwriteai.com">Up Write AI</a>
                    </li>
                    <li>
                        <a href="https://wisetalkapp.com">WiseTalk</a>
                    </li>
                    <li>
                        <a href="https://acallrecorder.com">A Call Recorder</a>
                    </li>
                    <li>
                        <a href="https://studycardsapp.com">StudyCards</a>
                    </li>
                    <li>
                        <a href="https://photodj.me">PhotoDj</a>
                    </li>
                    <li>
                        <a href="#babyTube" role="button"
                           onClick={() => _this.props.navigate('BabyTube')}>BabyTube</a>
                    </li>
                    <li>
                        <a href="#BabyMonitor" role="button"
                           onClick={() => _this.props.navigate('BabyMonitor')}>Baby Monitor</a>
                    </li>
                    <li>
                        <a href="#support" role="button"
                           onClick={() => _this.props.navigate('Support')}>Support</a>
                    </li>
                </ul>
            </div>
        </div>
    }
}

export default HeaderNavCompact;